import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import { SERVICE_UNAVAILABLE } from '../../controllers/coordination/utils/status-codes';
import ALLOW_CORS_WHITELIST from '../allow-cors-whitelist';
export var MAXIMUM_WAIT_TIME_MINUTES = 60;
export function errorIfNotOk(_x) {
  return _errorIfNotOk.apply(this, arguments);
}
function _errorIfNotOk() {
  _errorIfNotOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (response.ok) {
            _context.next = 8;
            break;
          }
          _context.t0 = Error;
          _context.t1 = "".concat(response.status, ": ");
          _context.next = 5;
          return response.text();
        case 5:
          _context.t2 = _context.sent;
          _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
          throw (0, _context.t0)(_context.t3);
        case 8:
          return _context.abrupt("return", response);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _errorIfNotOk.apply(this, arguments);
}
export function pullResponseTextIfNotOk(_x2) {
  return _pullResponseTextIfNotOk.apply(this, arguments);
}
function _pullResponseTextIfNotOk() {
  _pullResponseTextIfNotOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (response.ok) {
            _context2.next = 3;
            break;
          }
          _context2.next = 3;
          return response.text();
        case 3:
          return _context2.abrupt("return", response);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _pullResponseTextIfNotOk.apply(this, arguments);
}
function basicStargateRetryCondition(response) {
  var failureCategory = response.headers.get('X-Failure-Category');
  var failureCategoryIsThrottled = !!failureCategory && failureCategory.toLowerCase() === 'throttled';
  return response.status === SERVICE_UNAVAILABLE && failureCategoryIsThrottled;
}
export function stargateFetch(input, reqOptions) {
  var retryCondition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : basicStargateRetryCondition;
  return fetchWithRetry(input, retryCondition, augmentOptionsWithSameOriginCredentials(reqOptions));
}
export function stargateFetchRetryOn5xx(input, reqOptions) {
  return stargateFetch(input, reqOptions, function (response) {
    return response.status >= 500 && response.status <= 599;
  });
}
export function augmentOptionsWithSameOriginCredentials(reqOptions) {
  return _objectSpread(_objectSpread({}, reqOptions), {}, {
    credentials: ALLOW_CORS_WHITELIST.includes(location.host) ? 'include' : 'same-origin'
  });
}
function handleFetchResultAndRetryIfNeeded(fetchResult, retryCondition, retry) {
  return fetchResult.then(function (r) {
    return retryCondition(r) ? retry() : Promise.resolve(r);
  }).catch(retry);
}
function fetchWithRetry(input, retryCondition, reqOptions) {
  return handleFetchResultAndRetryIfNeeded(fetch(input, reqOptions), retryCondition, function () {
    return retryFetchWithBackoff(input, retryCondition, reqOptions);
  });
}
function retryFetchWithBackoff(input, retryCondition, reqOptions) {
  var waitTimeMinutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return handleFetchResultAndRetryIfNeeded(fetchAfter(input, waitTimeMinutes, reqOptions), retryCondition, function () {
    return retryFetchWithBackoff(input, retryCondition, reqOptions, Math.min(waitTimeMinutes === 0 ? 1 : waitTimeMinutes * 2, MAXIMUM_WAIT_TIME_MINUTES));
  });
}
export var REQUEST_STAGGER_DELAY_MAXIMUM_MS = 5000;
function fetchAfter(input, waitTimeMinutes, reqOptions) {
  var staggerDelay = Math.round(Math.random() * REQUEST_STAGGER_DELAY_MAXIMUM_MS);
  var delay = waitTimeMinutes ? waitTimeMinutes * 60 * 1000 + staggerDelay : 0;
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      fetch(input, reqOptions).then(resolve).catch(reject);
    }, delay);
  });
}